// Terugkomende nav (Rick, 26 sep 2026; DESIGN.md §6 Navigatie). Drie standen op .kop-site:
// vrij (geen klasse: in de flow, scrolt weg als altijd), .terug (sticky op top 0, in beeld)
// en .terug.weg (sticky, omhoog uit beeld geschoven). Omlaag scrollen verbergt, 8px omhoog
// haalt terug. html.kop-in laat de sticky kolommen meezakken (--kop-zicht in theme.css).

const kop = document.querySelector('.kop-site');
if (kop) {
  const html = document.documentElement;
  const usp = kop.previousElementSibling; // de USP-regel scrolt altijd weg; de nav begint eronder
  const DREMPEL = 8; // px omhoog voordat de nav komt: een trillend touchpad telt niet
  let vorige = scrollY;
  let omhoog = 0;

  const meet = () => html.style.setProperty('--kop-h', `${kop.offsetHeight}px`);
  meet();
  new ResizeObserver(meet).observe(kop);

  const toon = () => {
    if (!kop.classList.contains('terug')) {
      // Uit de vrije stand hangt hij net boven beeld: eerst zonder beweging naar top 0 en
      // verborgen, dan inschuiven. Anders glijdt hij eerst zichtbaar omhoog weg.
      kop.style.transition = 'none';
      kop.classList.add('terug', 'weg');
      kop.offsetHeight; // lay-out afdwingen vóór de beweging aangaat
      kop.style.transition = '';
    }
    kop.classList.remove('weg');
    html.classList.add('kop-in');
  };
  const verberg = () => {
    kop.classList.toggle('weg', kop.classList.contains('terug'));
    html.classList.remove('kop-in');
  };
  const vrij = () => {
    kop.classList.remove('terug', 'weg');
    html.classList.remove('kop-in');
  };
  // Open zoeklade of taalkiezer, of toetsenbordfocus in de nav: blijven staan.
  const vast = () => kop.querySelector('.zoek-lade[open], details[open], :focus-visible');

  addEventListener('scroll', () => {
    const y = scrollY;
    const dy = y - vorige;
    vorige = y;
    if (y > html.scrollHeight - innerHeight) return; // iOS-stuiter onderaan is geen omhoog
    const begin = usp ? usp.getBoundingClientRect().bottom + y : 0;
    if (y <= begin) { vrij(); omhoog = 0; return; }
    if (dy > 0) { omhoog = 0; if (!vast()) verberg(); return; }
    omhoog -= dy;
    // Vrij en nog half in beeld: de gewone scroll brengt hem terug, geen sprong.
    if (omhoog >= DREMPEL && (kop.classList.contains('terug') || y > begin + kop.offsetHeight)) toon();
  }, { passive: true });

  // Tab naar een verborgen nav: eerst in beeld.
  kop.addEventListener('focusin', () => { if (kop.classList.contains('weg')) toon(); });
}
